"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs — v1
 * API v1 documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfSignupAvailabilityResponseDto = instanceOfSignupAvailabilityResponseDto;
exports.SignupAvailabilityResponseDtoFromJSON = SignupAvailabilityResponseDtoFromJSON;
exports.SignupAvailabilityResponseDtoFromJSONTyped = SignupAvailabilityResponseDtoFromJSONTyped;
exports.SignupAvailabilityResponseDtoToJSON = SignupAvailabilityResponseDtoToJSON;
exports.SignupAvailabilityResponseDtoToJSONTyped = SignupAvailabilityResponseDtoToJSONTyped;
/**
 * Check if a given object implements the SignupAvailabilityResponseDto interface.
 */
function instanceOfSignupAvailabilityResponseDto(value) {
    if (!('phoneAvailable' in value) || value['phoneAvailable'] === undefined)
        return false;
    if (!('emailAvailable' in value) || value['emailAvailable'] === undefined)
        return false;
    return true;
}
function SignupAvailabilityResponseDtoFromJSON(json) {
    return SignupAvailabilityResponseDtoFromJSONTyped(json, false);
}
function SignupAvailabilityResponseDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'phoneAvailable': json['phoneAvailable'],
        'emailAvailable': json['emailAvailable'],
    };
}
function SignupAvailabilityResponseDtoToJSON(json) {
    return SignupAvailabilityResponseDtoToJSONTyped(json, false);
}
function SignupAvailabilityResponseDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'phoneAvailable': value['phoneAvailable'],
        'emailAvailable': value['emailAvailable'],
    };
}
